var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockFillIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:lock-fill",
    clipPath: "url(#clip0_261_5437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 9.3335C7 7.47698 7.7375 5.6965 9.05025 4.38375C10.363 3.07099 12.1435 2.3335 14 2.3335C15.8565 2.3335 17.637 3.07099 18.9497 4.38375C20.2625 5.6965 21 7.47698 21 9.3335H22.1667C22.7855 9.3335 23.379 9.57933 23.8166 10.0169C24.2542 10.4545 24.5 11.048 24.5 11.6668V23.3335C24.5 23.9523 24.2542 24.5458 23.8166 24.9834C23.379 25.421 22.7855 25.6668 22.1667 25.6668H5.83333C5.21449 25.6668 4.621 25.421 4.18342 24.9834C3.74583 24.5458 3.5 23.9523 3.5 23.3335V11.6668C3.5 11.048 3.74583 10.4545 4.18342 10.0169C4.621 9.57933 5.21449 9.3335 5.83333 9.3335H7ZM14 4.66683C15.2377 4.66683 16.4247 5.15849 17.2998 6.03366C18.175 6.90883 18.6667 8.09582 18.6667 9.3335H9.33333C9.33333 8.09582 9.825 6.90883 10.7002 6.03366C11.5753 5.15849 12.7623 4.66683 14 4.66683ZM16.3333 16.3335C16.3333 16.7431 16.2255 17.1454 16.0207 17.5001C15.8159 17.8548 15.5214 18.1494 15.1667 18.3542V19.8335C15.1667 20.1429 15.0437 20.4397 14.825 20.6585C14.6062 20.8772 14.3094 21.0002 14 21.0002C13.6906 21.0002 13.3938 20.8772 13.175 20.6585C12.9562 20.4397 12.8333 20.1429 12.8333 19.8335V18.3542C12.3885 18.0973 12.0409 17.7009 11.8444 17.2264C11.6478 16.7518 11.6133 16.2257 11.7463 15.7296C11.8792 15.2335 12.1721 14.7951 12.5796 14.4824C12.9871 14.1697 13.4864 14.0002 14 14.0002C14.6188 14.0002 15.2123 14.246 15.6499 14.6836C16.0875 15.1212 16.3333 15.7147 16.3333 16.3335Z",
    fill: "#282828"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_5437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFillIcon);
export default __webpack_public_path__ + "static/media/lock-fill-icon.8d867292abbfd8f35a800154ad1a60f9.svg";
export { ForwardRef as ReactComponent };